import PropTypes from "prop-types"
import { Paper, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material"
import TablePagination from "components/material/table-pagination"

function UnmatchedSecurities({
  securities,
  numberOfTableRows,
  securitiesPage,
  showSecuritiesPage,
  downloadButton,
  type,
}) {
  return <div className="unmatched-securities">
    <Paper elevation={1} square>
      <div className="scan-preview-header">
        <div className="unmatched-securities-title">The following {securities.numberOfSecurities} securities have not been matched</div>
        {downloadButton}
      </div>
      <Table className="scan-preview-table">
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox" className="number-header" />
            <TableCell className="security-identifier">Identifier</TableCell>
            {type === "watchlist"
              ? <TableCell>Asset class</TableCell>
              : <>
                <TableCell>From</TableCell>
                <TableCell>To</TableCell>
                <TableCell align="right">Max % GMV</TableCell>
                <TableCell align="right">Counts</TableCell>
              </>}
          </TableRow>
        </TableHead>
        <TableBody>
          {securities.securities.map((security, i) =>
            <TableRow key={i}>
              <TableCell padding="checkbox" align="right" className="security-number">{i + 1}</TableCell>
              <TableCell className="security-identifier">{security.ticker || security.sedol}</TableCell>
              {type === "watchlist"
                ? <TableCell>{security.assetClass}</TableCell>
                : <>
                  <TableCell>{security.from}</TableCell>
                  <TableCell>{security.to}</TableCell>
                  <TableCell align="right">{security.maxGMV}</TableCell>
                  <TableCell align="right">{security.counts}</TableCell>
                </>}
            </TableRow>,
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={securities.numberOfSecurities}
        rowsPerPage={numberOfTableRows}
        page={securitiesPage}
        onPageChange={showSecuritiesPage}
      />
    </Paper>
  </div>
}

UnmatchedSecurities.propTypes = {
  securities: PropTypes.object.isRequired,
  securitiesPage: PropTypes.number.isRequired,
  showSecuritiesPage: PropTypes.func.isRequired,
  numberOfTableRows: PropTypes.number.isRequired,
  downloadButton: PropTypes.element.isRequired,
  type: PropTypes.string.isRequired,
}

export default UnmatchedSecurities
